import React, { useContext } from 'react';
import { LykioContext } from "../routing/LykioAuthorizedRoute";
import Accordion from 'react-bootstrap/Accordion';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';


function Welcome() {
    const context = useContext(LykioContext);
    const userRole = localStorage.getItem('userRole');
    const tenantProperties = context.tenantProperties;
	const storiesName = tenantProperties && tenantProperties.storiesName ? tenantProperties.storiesName : "Stories";
    const tenantName = tenantProperties && tenantProperties.name ? tenantProperties.name : "Lykio";
    const categoriesName = tenantProperties && tenantProperties.categoriesName ? tenantProperties.categoriesName : "Categories";
    const initiative = (tenantProperties && tenantProperties.initiative) && tenantProperties.initiative;
    const welcomeMessage = (tenantProperties && tenantProperties.welcomeMessage) && tenantProperties.welcomeMessage;
    return ( <div className="lykioccs-main-content" style={{backgroundColor:'white'}}>
        <Container>
            <Row>
                <Tabs defaultActiveKey="welcome" id="uncontrolled-tab-example" className="mb-3">
                <Tab eventKey="welcome" title="Welcome">
                    <p>{`Welcome to Lykio for  ${tenantName} ${initiative ? initiative : ''}`}</p>
                    <p>{welcomeMessage!=='undefined' && welcomeMessage}</p>
                </Tab>
                <Tab eventKey="units" title={`${categoriesName} and ${storiesName}`}>
                    <p>units</p>
                    <p>what the categories are</p>
                    <p>how many XP do I get for completing, commenting and rating</p>
                    <p>stories, what can I upload</p>
                    <p>how many XP do I get</p>
                </Tab>
                <Tab eventKey="social" title="Social">
                    <p>How can I follow someone, what happens when I follow someone</p>
                </Tab>
                <Tab eventKey="play" title="Playlists">
                    <p>How to create my custom playlist out of lessons and stories</p>
                    <p>Where can In see my playlists</p>
                    {(userRole==='teacher' || userRole==='manager' || userRole==='admin') && 
                    <p>Assign playlists</p>
                    }
                </Tab>
                <Tab eventKey="settings" title="Customize your experience">
                    <p>Uploading picture and setting up my account</p>
                    <p>Changing languages</p>
                    <p>Modifying the home screen</p>
                    <p>Picking a custom theme</p>
                </Tab>
                {((userRole==='teacher') || userRole==='manager' || (userRole==='admin')) &&
                <Tab eventKey="admin" title="Admin Options">
                    {(userRole==='teacher' || userRole==='manager') && <div>
                        <p>Reporting</p>
                        <p>User Management</p>
                        <p>Adding Content</p>
                        </div>}
                    {(userRole==='admin') && <div>
                        <p>Reporting</p>
                        <p>Adding Custom Awards</p>
                        <p>Customizing Lykio for your users</p>
                        <p>Adding Categories</p>
                        <p>Moderating content</p>
                        <p>Managing groups, departments and users</p>
                        <p>Adding Content</p>
                        </div>}
                </Tab>}
                </Tabs>
            </Row>
        </Container>
    </div> );
}

export default Welcome;